<div class="gateway-order-create-container">
  <h3>Create New Gateway Order</h3>
  @if (gatewayOrderForm) {
    <form [formGroup]="gatewayOrderForm">
      <div class="mb-3">
        <label for="orderName" class="form-label">Gateway Order Name*</label>
        <input id="orderName" class="form-control" type="text" formControlName="orderName" maxlength="100" required>
        <div *ngIf="orderName?.invalid && (orderName?.dirty || orderName?.touched)" class="alert alert-danger">
          <div *ngIf="orderName?.errors?.['required']">Gateway order name is required.</div>
          <div *ngIf="orderName?.errors?.['maxlength']">Gateway order name cannot exceed 100 characters.</div>
        </div>
      </div>

      <div class="mb-3">
        <label for="hubTenantName" class="form-label">Hub Environment*</label>
        <mat-select id="hubTenantName" class="form-control" formControlName="hubTenantName">
          @for (hubEnvironmentOption of hubEnvironmentOptions; track hubEnvironmentOption.value) {
            <mat-option [value]="hubEnvironmentOption.value">{{hubEnvironmentOption.label}}</mat-option>
          }
        </mat-select>
        <div *ngIf="hubEnvironmentLoadError" class="alert alert-danger">{{hubEnvironmentLoadError}}</div>
      </div>

      <div class="mb-3">
        <label for="gatewayOrderType" class="form-label">Gateway Order Type*</label>
        <mat-select id="gatewayOrderType" class="form-control" formControlName="gatewayOrderType">
          <mat-option [value]="GatewayOrderType.CREATE_DEVICES">CREATE DEVICES</mat-option>
        </mat-select>
      </div>

      <div class="mb-3">
        <label for="environmentKey" class="form-label">Environment*</label>
        <mat-select id="environmentKey" class="form-control" formControlName="environmentKey">
          @for (gatewayEnvironment of gatewayEnvironments; track gatewayEnvironment.environmentKey) {
            <mat-option [value]="gatewayEnvironment.environmentKey">{{gatewayEnvironment.environmentKey}}</mat-option>
          }
        </mat-select>
        <div *ngIf="environmentLoadError" class="alert alert-danger">{{environmentLoadError}}</div>
      </div>

      <button class="btn btn-light gateway-order-form-button" type="submit"
              (mousedown)="prevent($event)" (click)="cancel()">CANCEL</button>
      <button class="btn btn-primary gateway-order-form-button" type="submit"
              (click)="submit()" [disabled]="gatewayOrderForm.invalid">SUBMIT</button>
    </form>
  }
</div>
